export default "__VITE_ASSET__DdT924Ss__"